module.exports = __webpack_public_path__ + "img/8.6e31d884.jpg";